import styled from 'styled-components';

export const ChatDropdownOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
`;

export const ChatDropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 380px;
  height: 520px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 991px) {
    position: fixed;
    top: 56px;
    left: 0;
    right: 0;
    width: 100%;
    height: calc(100vh - 56px);
    height: calc(100dvh - 56px);
    border-radius: 0;
  }
`;

export const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px 0;
  gap: 0;
  border-bottom: none;
`;

export const ChatTab = styled.button`
  flex: 1;
  padding: 10px 8px;
  border: none;
  background: transparent;
  font-size: 0.85rem;
  font-weight: 600;
  color: ${props => (props.active ? '#0747a6' : '#8993a4')};
  border-bottom: 2px solid ${props => (props.active ? '#0747a6' : 'transparent')};
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  white-space: nowrap;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  overflow: visible;

  &:hover {
    color: #0747a6;
  }
`;

export const TabBadge = styled.span`
  background: #e74c3c;
  color: #fff;
  font-size: 0.6rem;
  font-weight: 700;
  min-width: 18px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 8px;
  padding: 0 4px;
  display: inline-block;
  vertical-align: middle;
`;

export const ChatBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
  min-height: 0;
  max-height: 420px;
`;

export const NovoChatButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: calc(100% - 24px);
  margin: 4px 12px 8px;
  padding: 10px 14px;
  border: 1px dashed #0747a6;
  border-radius: 8px;
  background: rgba(7, 71, 166, 0.04);
  color: #0747a6;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(7, 71, 166, 0.1);
    border-style: solid;
  }
`;

export const ConversaItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.15s ease;
  gap: 12px;

  &:hover {
    background: #f4f5f7;
  }
`;

export const ConversaAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.color || '#0747a6'};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.8rem;
  flex-shrink: 0;
`;

export const ConversaInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ConversaNome = styled.div`
  font-size: 0.85rem;
  font-weight: 600;
  color: #172b4d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ConversaPreview = styled.div`
  font-size: 0.78rem;
  color: #8993a4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
`;

export const ConversaNaoLidas = styled.div`
  font-size: 0.72rem;
  font-weight: 600;
  color: #e74c3c;
  margin-top: 2px;
`;

export const ConversaMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
`;

export const ConversaHora = styled.span`
  font-size: 0.7rem;
  color: #8993a4;
`;

export const ConversaBadge = styled.span`
  background: #e74c3c;
  color: #fff;
  font-size: 0.6rem;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 9px;
  padding: 0 5px;
`;

export const SubHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  border-bottom: 1px solid #ebecf0;
`;

export const BtnVoltar = styled.button`
  background: transparent;
  border: none;
  color: #8993a4;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  border-radius: 4px;

  &:hover {
    color: #0747a6;
    background: #f4f5f7;
  }
`;

export const SubHeaderTitulo = styled.span`
  font-size: 0.9rem;
  font-weight: 600;
  color: #172b4d;
`;

export const DepartamentoItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.15s ease;
  gap: 12px;
  font-size: 0.85rem;
  color: #172b4d;

  &:hover {
    background: #f4f5f7;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #8993a4;
  font-size: 0.85rem;
  text-align: center;

  svg {
    margin-bottom: 12px;
    opacity: 0.4;
  }
`;

export const MensagensContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
`;

export const MensagemBolha = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.minha ? 'flex-end' : 'flex-start')};
  max-width: 85%;
  align-self: ${props => (props.minha ? 'flex-end' : 'flex-start')};
`;

export const MensagemAutor = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
`;

export const MensagemAutorFoto = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
`;

export const MensagemAutorNome = styled.span`
  font-size: 0.7rem;
  font-weight: 600;
  color: #8993a4;
`;

export const MensagemTexto = styled.div`
  background: ${props => (props.minha ? '#0747a6' : '#f4f5f7')};
  color: ${props => (props.minha ? '#fff' : '#172b4d')};
  padding: 8px 12px;
  border-radius: ${props =>
    props.minha ? '12px 12px 4px 12px' : '12px 12px 12px 4px'};
  font-size: 0.84rem;
  line-height: 1.4;
  word-break: break-word;
`;

export const MensagemAnexoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  margin-top: 4px;
  background: ${props => (props.minha ? 'rgba(255,255,255,0.15)' : '#e9ecef')};
  border-radius: 6px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background 0.15s ease;
  max-width: 200px;

  &:hover {
    background: ${props => (props.minha ? 'rgba(255,255,255,0.25)' : '#dee2e6')};
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const MensagemAssuntoTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #e3f2fd;
  color: #0747a6;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 10px;
  margin-bottom: 4px;
`;

export const MensagemHora = styled.span`
  font-size: 0.65rem;
  color: #8993a4;
  margin-top: 2px;
`;

export const ChatInputContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-top: 1px solid #ebecf0;
  gap: 8px;
`;

export const ChatInput = styled.input`
  flex: 1;
  border: 1px solid #dfe1e6;
  border-radius: 20px;
  padding: 8px 14px;
  font-size: 0.84rem;
  outline: none;
  transition: border-color 0.2s ease;
  width: 100%;
  &:focus {
    border-color: #0747a6;
  }

  &::placeholder {
    color: #b3bac5;
  }
`;

export const ChatInputBtn = styled.button`
  background: #0747a6;
  border: none;
  color: #fff;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #0a5cc8;
  }

  &:disabled {
    background: #b3bac5;
    cursor: not-allowed;
  }
`;

export const TopicoCard = styled.div`
  padding: 10px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f4f5f7;
  transition: background 0.15s ease;
  &:hover {
    background: #f4f5f7;
  }
`;

export const TopicoTitulo = styled.div`
  font-size: 0.85rem;
  font-weight: 600;
  color: #172b4d;
  margin-bottom: 2px;
`;

export const TopicoTexto = styled.div`
  font-size: 0.78rem;
  color: #8993a4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const SeguirParaChatContainer = styled.div`
  padding: 10px 16px;
  border-top: 1px solid #ebecf0;
  flex-shrink: 0;
`;

export const SeguirParaChatBtn = styled.button`
  width: 100%;
  padding: 8px 16px;
  background: #0747a6;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
  &:hover {
    background: #0052cc;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const AbaTitulo = styled.div`
  padding: 8px 16px 4px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #8993a4;
  border-bottom: 1px solid #f4f5f7;
`;

export const ComunicadoEditadoLabel = styled.span`
  font-size: 0.6rem;
  color: #8993a4;
  font-style: italic;
  margin-top: 2px;
`;

export const ComunicadoAcoes = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 2px;
`;

export const ComunicadoAcaoBtn = styled.button`
  background: transparent;
  border: none;
  color: #8993a4;
  cursor: pointer;
  padding: 2px 4px;
  font-size: 0.65rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 3px;

  &:hover {
    color: ${props => (props.danger ? '#e74c3c' : '#0747a6')};
    background: #f4f5f7;
  }
`;

export const MensagemRodape = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
`;

export const MensagemInfoIcon = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #b3bac5;
  display: flex;
  align-items: center;
  line-height: 1;

  &:hover {
    color: #0747a6;
  }
`;

export const ModalLeiturasOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
`;

export const ModalLeiturasContainer = styled.div`
  background: #fff;
  border-radius: 10px;
  width: 320px;
  max-width: 90vw;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
  overflow: hidden;
`;

export const ModalLeiturasHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 0.88rem;
  font-weight: 600;
  color: #172b4d;
  border-bottom: 1px solid #ebecf0;
`;

export const ModalLeiturasBody = styled.div`
  max-height: 260px;
  overflow-y: auto;
`;

export const ModalLeiturasItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  font-size: 0.82rem;
  color: #172b4d;
  border-bottom: 1px solid #f4f5f7;

  &:last-child {
    border-bottom: none;
  }
`;
